import React from "react";
import "../sass/Content.scss";
import satelliteCrowd from "../sass/assets/satellite-crowd.png";

const HowItWorks = () => {
  return (
    <div className="contentWrapper">
      {/* <img className="heroImg" alt="satellite" src={satelliteCrowd} /> */}
      <h1>How it works</h1>
      <p>
        With more than 1,000 satellites looking at the Earth every day from
        space, it has recently become possible to truly observe the pace of
        change as it happens. Raw datasets can be rendered on the map view, and
        statistics from each day/week/month/year can be plotted and compared.
        Fused datasets are computed by leveraging a comprehensive collection of
        spatial algorithms and analytical methods. These consist of finding
        hidden patterns in the data using machine learning and deep learning.
        While some sample algorithms are included, we encourage users to submit
        their own algorithms to uncover insights from the data as per their area
        of interest. For example, one could monitor temperature patterns, tidal
        patterns and ocean currents to understand the movement of fishing zones.
      </p>

      <p>
        The ability to track at-risk areas in combination with historical data,
        weather data, and geospatial data gives better information to predict
        natural disasters and events of economic, environmental, and social
        importance.
      </p>
    </div>
  );
};

export default HowItWorks;
